import { ICellRendererParams } from 'ag-grid-community';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { Price } from 'core/elements';

interface IProps extends ICellRendererParams {
  value: number;
}

export const ExtCostCell = ({ value }: IProps) => {
  if (!value) {
    return DEFAULT_PLACEHOLDER;
  }

  return <Price amount={value} />;
};
